/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Directives
import { disableAll } from "@/directives/disableAll";

// Plugins
import { registerPlugins } from "@/plugins";

// Components
import App from "./App.vue";

// Composables
import { createApp } from "vue";
const app = createApp(App);
app.directive("disable-all", disableAll);

registerPlugins(app);

app.mount("#app");
